import { adminConstants } from '../constant/admin-constant';
import { alertActions } from './alert-actions';
import { history } from '../../helper/history';
import { userService } from '../../services/user';
import { listService } from '../../services/lists';
import { listTypeService } from '../../services/list-type';

export const listTypeActions = {
    // getCurrentUser,
    updatePermission,
    // getCountriesPagination,
    getAllListTypes,
    getList,
    getListTypeItem,
    storeListTypeItem,
    editListType,
    deleteListType,
    getParentData,
};

function updatePermission(userId) {

    return dispatch => {
        dispatch(request());
        userService.updatePermission(userId)
            .then(
                response => {
                    dispatch(success(response));
                    dispatch(alertActions.success(response.message));
                    setTimeout(function () {
                        history.go(0);
                    }, 500);
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    }

    function request() { return { type: adminConstants.CHANGE_PRIMARY_USER_REQUEST } }
    function success(response) { return { type: adminConstants.CHANGE_PRIMARY_USER_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.CHANGE_PRIMARY_USER_FAILURE, payload: error } }

}

// function getCountriesPagination(page, filter, sort, pageSize) {
//     return dispatch => {
//         console.log('in the countries pagination call');
//         return;
//         // dispatch(request())
//         // countryService.getCountriesPagination(page, filter, sort, pageSize)
//         //     .then(
//         //         response => {
//         //             dispatch(success(response));
//         //         },
//         //         error => {
//         //             dispatch(failure(error));
//         //             dispatch(alertActions.error(error));
//         //         }
//         //     );
//     };

//     function request() { return { type: adminConstants.PAGINATION_COUNTRIES_REQUEST } }
//     function success(response) { return { type: adminConstants.PAGINATION_COUNTRIES_SUCCESS, payload: response } }
//     function failure(error) { return { type: adminConstants.PAGINATION_COUNTRIES_FAILURE, payload: error } }
// }


function getAllListTypes(page, filter, sort, pageSize) {
    return dispatch => {
        dispatch(request())
        listTypeService.getAllListTypes(page, filter, sort, pageSize)
            .then(
                response => {
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() { return { type: adminConstants.GET_ALL_LIST_TYPES_REQUEST } }
    function success(response) { return { type: adminConstants.GET_ALL_LIST_TYPES_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.GET_ALL_LIST_TYPES_FAILURE, payload: error } }
}

function getParentData(parentId) {
    return dispatch => {
        dispatch(request())
        listTypeService.getParentData(parentId)
            .then(
                response => {
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request() { return { type: adminConstants.GET_ALL_LIST_TYPES_PARENT_REQUEST } }
    function success(response) { return { type: adminConstants.GET_ALL_LIST_TYPES_PARENT_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.GET_ALL_LIST_TYPES_PARENT_FAILURE, payload: error } }
}

function getList(id, type) {
    return dispatch => {
        dispatch(request());
        listService.getList(id)
            .then(
                list => {
                    dispatch(success(list));

                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));

                }
            );
    }

    function request() { return { type: adminConstants.GET_LIST_REQUEST } }
    function success(list) { return { type: adminConstants.GET_LIST_SUCCESS, payload: { list, type } } }
    function failure(error) { return { type: adminConstants.GET_LIST_FAILURE, payload: error } }
}


function getListTypeItem(id) {
    return dispatch => {
        dispatch(request());
        return listTypeService.getListTypeItem(id)
            .then(
                list_type => {
                    dispatch(success(list_type));
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));

                }
            );
    }

    function request() { return { type: adminConstants.GET_LIST_TYPE_ITEM_REQUEST } }
    function success(list_type) { return { type: adminConstants.GET_LIST_TYPE_ITEM_SUCCESS, payload: list_type } }
    function failure(error) { return { type: adminConstants.GET_LIST_TYPE_ITEM_FAILURE, payload: error } }
}

function storeListTypeItem(listTypeData) {
    return dispatch => {
        dispatch(request());
        return listTypeService.storeListTypeItem(listTypeData)
            .then(
                response => {
                    console.log('response 123', response);
                    dispatch(success(response));
                    dispatch(alertActions.success(response.message));
                    return listTypeData;
                    // setTimeout(function(){ 
                    //     history.go(0);
                    // }, 1500);
                },
                error => {
                    // console.log('error 123', error);
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                    return Promise.reject(error);
                }
            );
    }

    function request() { return { type: adminConstants.STORE_LIST_ITEM_REQUEST } }
    function success(response) { return { type: adminConstants.STORE_LIST_ITEM_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.STORE_LIST_ITEM_FAILURE, payload: error } }
}


function deleteListType(list_type_id) {
    return dispatch => {
        dispatch(request());
        return listTypeService.deleteListType(list_type_id)
            .then(
                response => {
                    dispatch(success(response));
                    dispatch(alertActions.success(response.message));
                    // setTimeout(function(){ 
                    //     history.go(0);
                    // }, 1500);
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    }

    function request() { return { type: adminConstants.DELETE_LIST_ITEM_REQUEST } }
    function success(response) { return { type: adminConstants.DELETE_LIST_ITEM_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.DELETE_LIST_ITEM_FAILURE, payload: error } }
}


function editListType(listTypeData, list_type_id) {
    return dispatch => {
        dispatch(request());
        return listTypeService.editListType(listTypeData, list_type_id)
            .then(
                response => {
                    dispatch(success(response));
                    dispatch(alertActions.success(response.message));
                    console.log('edit');
                    return listTypeData;
                    // setTimeout(function(){ 
                    //     history.go(0);
                    // }, 1500);
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    }

    function request() { return { type: adminConstants.EDIT_LIST_TYPE_ITEM_REQUEST } }
    function success(response) { return { type: adminConstants.EDIT_LIST_TYPE_ITEM_SUCCESS, payload: response } }
    function failure(error) { return { type: adminConstants.EDIT_LIST_TYPE_ITEM_FAILURE, payload: error } }
}


// WEBPACK FOOTER //
// ./src/redux/actions/list-type-actions.jsx